"use client"

import { ProductPageAccordion } from "@/components/molecules"
import { AdditionalAttributeProps } from "@/types/product"
import { useTranslate } from "@tolgee/react"

export const ProductAdditionalAttributes = ({
  attributes,
}: {
  attributes: AdditionalAttributeProps[]
}) => {
  const { t } = useTranslate()
  if (!attributes.length) return null

  return (
    <ProductPageAccordion heading={t("product_additional_attributes.heading")} defaultOpen={false}>
      {attributes.map((attribute) => (
        <div
          key={attribute.id}
          className="border rounded-sm grid grid-cols-2 text-center label-md"
        >
          <div className="border-r py-3">{attribute.attribute.name}</div>
          <div className="py-3">{attribute.value}</div>
        </div>
      ))}
    </ProductPageAccordion>
  )
}
